document.addEventListener("DOMContentLoaded", () => {
  const videos = document.querySelectorAll("video[data-lazy-video='true']");

  const loadVideo = (video) => {
    if (video.dataset.loaded === "true") return;
    video.dataset.loaded = "true";

    // Swap in real sources
    video.querySelectorAll("source[data-src]").forEach((s) => {
      s.src = s.dataset.src;
      s.removeAttribute("data-src");
    });

    video.load();

    // Autoplay if allowed
    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === "function") playPromise.catch(() => {});
  };

  // If IntersectionObserver is supported, wait until visible
  if ("IntersectionObserver" in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadVideo(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: "200px" });

    videos.forEach((v) => io.observe(v));
  } else {
    // Fallback: load after page load
    videos.forEach(loadVideo);
  }
});